import { Box, Stack, Typography } from '@mui/material';
import { fmt } from '@/features/notas/calculo';
import { Alvo, AreaGrafico, COR, VARIAVEIS_GRAFICO } from './base';

export interface Parte {
  rotulo: string;
  peso: number;
  nota: number | null;
}

/**
 * Quanto cada parte somou na prova (peso × nota) e quanto deixou de somar, numa barra de 0 a 10.
 * Três partes, cada uma com a sua cor e legenda com os valores (a cor nunca é a única pista).
 */
export function Composicao({ partes, rotulo }: { partes: Parte[]; rotulo: string }) {
  const total = partes.reduce((s, p) => s + p.peso * (p.nota ?? 0), 0);
  return (
    <Box>
      <AreaGrafico altura={44} rotulo={`${rotulo}: ${fmt(total)} de 10`}>
        {(w) => {
          const x = (v: number) => (v / 10) * w;
          let acc = 0;
          return (
            <g>
              <rect x={0} y={8} width={w} height={22} rx={6} fill={COR.trilho} />
              {partes.map((p, i) => {
                const v = p.peso * (p.nota ?? 0);
                const x0 = x(acc);
                acc += v;
                const largura = Math.max(0, x(acc) - x0 - 2);
                return (
                  <Alvo
                    key={p.rotulo}
                    titulo={`${p.rotulo}: nota ${fmt(p.nota)} × peso ${fmt(p.peso, 1)} = ${fmt(v)} ponto(s); poderia somar ${fmt(p.peso * 10)}`}
                  >
                    <rect x={x0} y={8} width={largura} height={22} rx={i === 0 ? 6 : 2} fill={COR.serie[i % 3]} />
                  </Alvo>
                );
              })}
            </g>
          );
        }}
      </AreaGrafico>
      <Stack direction="row" useFlexGap sx={[VARIAVEIS_GRAFICO, { flexWrap: 'wrap', columnGap: 2.5, rowGap: 0.5, mt: 0.5 }]}>
        {partes.map((p, i) => (
          <Stack key={p.rotulo} direction="row" spacing={0.75} sx={{ alignItems: 'center' }}>
            <Box sx={{ width: 12, height: 12, borderRadius: '4px', bgcolor: COR.serie[i % 3] }} />
            <Typography variant="body2" color="text.secondary">
              {p.rotulo} <strong style={{ color: 'var(--g-texto)' }}>{fmt(p.peso * (p.nota ?? 0))}</strong> / {fmt(p.peso * 10, 1)}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}
